import { Car, Save, Navigation, ArrowRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const ICONS = [Car, Save, Navigation];

export default function HowItWorks() {
  const { t, isRTL } = useI18n();
  const steps = t("how.steps");

  return (
    <section id="how" className="section bg-white" data-testid="section-how">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="eyebrow">{t("how.eyebrow")}</div>
          <h2 className="h2 mt-4">{t("how.title")}</h2>
        </div>

        <div className="mt-14 relative grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          <div className="hidden md:block absolute top-16 left-[16%] right-[16%] h-px border-t-2 border-dashed border-brand-line" aria-hidden="true" />
          {steps.map((s, i) => {
            const Icon = ICONS[i] || Car;
            return (
              <div key={i} className="relative" data-testid={`how-step-${i}`}>
                <div className="card-soft p-8 h-full relative">
                  <div className="flex items-center justify-between">
                    <div className="h-12 w-12 rounded-2xl bg-brand-green text-white flex items-center justify-center shadow-soft">
                      <Icon className="h-5 w-5" />
                    </div>
                    <div className="text-5xl font-extrabold text-brand-green/15 leading-none">
                      {s.n}
                    </div>
                  </div>
                  <h3 className="mt-6 text-xl font-bold text-brand-charcoal">{s.t}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-brand-charcoal/70">{s.d}</p>
                </div>
                {i < steps.length - 1 && (
                  <div className="hidden md:flex absolute top-14 -end-4 z-10 h-8 w-8 rounded-full bg-white border border-brand-line items-center justify-center text-brand-green">
                    <ArrowRight className={`h-4 w-4 ${isRTL ? "rotate-180" : ""}`} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
